import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getQuizData,
  submitQuizData,
  getTimeSlots,
  createMeeting,
  getFaqList,
  getPricingList,
} from "../../utils/quiz-util";

export const getQuizDatareq = createAsyncThunk(
  "getQuizDatareq",
  async (res) => {
    const responce = await getQuizData(res);
    return responce.data;
  }
);

export const submitQuizDatareq = createAsyncThunk(
  "submitQuizDatareq",
  async (quizData) => {
    const responce = await submitQuizData(quizData);
    return responce;
  }
);

export const getTimeSlotsDatareq = createAsyncThunk(
  "getTimeSlotsDatareq",
  async (req) => {
    const responce = await getTimeSlots(req);
    return responce;
  }
);

export const createMeetingDatareq = createAsyncThunk(
  "createMeetingDatareq",
  async (req) => {
    const responce = await createMeeting(req);
    return responce;
  }
);

export const getFaqListDatareq = createAsyncThunk(
  "getFaqListDatareq",
  async () => {
    const responce = await getFaqList();
    return responce;
  }
);

export const getPricingListDatareq = createAsyncThunk(
  "getPricingListDatareq",
  async () => {
    const responce = await getPricingList();
    return responce;
  }
);

const quizSlice = createSlice({
  name: "quiz",
  initialState: {
    quizPageData: {},
    loading: false,
    error: null,
    submitting: false,
    submitError: null,
    submitSuccess: false,
    timeSlots: [],
    faqList: [],
    quizData: null,
    earthQuiz: null,
  },
  reducers: {
    resetQuizData: (state) => {
      console.log(">>>>>resetQuizData");
      state.quizData = null;
    },
    resetSubmitData: (state) => {
      state.submitting = false;
      state.submitError = null;
      state.submitSuccess = false;
    },
    updateEarthQuiz: (state, action) => {
      console.log('action.payload', action.payload)
      state.earthQuiz = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getQuizDatareq.fulfilled, (state, action) => {
        state.loading = false;
        state.quizPageData = action.payload;
        state.error = null;
      })
      .addCase(submitQuizDatareq.pending, (state) => {
        state.submitting = true;
        state.submitError = null;
        state.submitSuccess = false;
      })
      .addCase(submitQuizDatareq.fulfilled, (state, action) => {
        state.submitting = false;
        state.submitSuccess = true;
        state.submitError = null;
        state.quizData = action?.payload?.data?.data;
      })
      .addCase(submitQuizDatareq.rejected, (state, action) => {
        state.submitting = false;
        state.submitError = action.error.message;
        state.submitSuccess = false;
      })
      .addCase(getTimeSlotsDatareq.fulfilled, (state, action) => {
        state.loading = false;
        const freeSlots = action.payload.data.freeSlots;
        const ddlDataFreeSlots = freeSlots.map((slot) => {
          return {
            label: `${slot.start} to ${slot.end} IST`,
            value: `${slot.start} to ${slot.end}`,
          };
        });
        state.timeSlots = ddlDataFreeSlots;
        state.error = null;
      })
      .addCase(getTimeSlotsDatareq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getFaqListDatareq.fulfilled, (state, action) => {
        state.loading = false;
        state.faqList = action.payload.data;
        state.error = null;
      })
      .addCase(getFaqListDatareq.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      })
      .addCase(getPricingListDatareq.fulfilled, (state, action) => {
        state.loading = false;
        console.log("action.payload.data", action.payload.data);
        state.pricingList = action.payload.data.quizPricings;
        state.error = null;
      });
    // builder.addCase(getHomeDatareq.pending, (state, action) => {
    //   state.loading = true;
    // });
    // builder.addCase(getHomeDatareq.rejected, (state, action) => {
    //   state.loading = false;
    // });
  },
});

export const { resetQuizData, resetSubmitData, updateEarthQuiz } =
  quizSlice.actions;

export default quizSlice.reducer;
